<template>
  <BaseModal :modalTitle="$t('message.unsaved-changes')">
    <!-- Body in the default slot with min-h-20, not modalIntro — this is
         exactly how ConfirmationModal is built, and it is what gives every
         confirmation in the app the same height and spacing. -->
    <div class="mb-3 min-h-20">
      <p>{{ $t('message.unsaved-changes-lost') }}</p>
    </div>

    <template #buttons>
      <UiBaseButton
        :text="$t('action.cancel')"
        theme="neutral"
        @button-click="onStayClick" />
      <UiBaseButton
        :text="$t('action.continue')"
        theme="primary"
        @button-click="onLeaveClick" />
    </template>
  </BaseModal>
</template>

<script lang="ts">
// Mirrors ConfirmationModal's button layout on purpose — neutral "step back"
// on the left, primary "proceed with what you asked for" on the right. That
// also puts ModalHost's autofocus on the safe choice, since it focuses the
// first focusable element in the dialog.
export default {
  name: 'UnsavedChangesModal',
  emits: ['close'],
  props: {
    onLeave: {
      type: Function,
      required: true,
    },
    onStay: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      hasAnswered: false,
    }
  },
  methods: {
    onLeaveClick() {
      this.hasAnswered = true
      this.onLeave()
      this.$emit('close')
    },
    onStayClick() {
      this.hasAnswered = true
      this.onStay()
      this.$emit('close')
    },
  },
  beforeUnmount() {
    // ModalHost always renders its own X and lets Escape dismiss this dialog,
    // and it can also be popped by the ModalHost close path popping twice.
    // Either way the caller is awaiting an answer — without this fallback a
    // dismissed dialog would leave a router navigation hanging forever.
    // Dismissing therefore means stay, which is why Escape is safe here.
    if (!this.hasAnswered) {
      this.onStay()
    }
  },
}
</script>
